import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Template from "@/services/template/template";
import type { RegisterTemplate } from "@/dtos/Template.dto";

export function useCreateTemplate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: RegisterTemplate) => {
      const result = await Template.registerTemplate(payload);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to create template");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templates"] });
    },
  });
}
